import {
  Mail,
  Phone,
  Globe,
  User,
  Users,
  Target,
  PencilLine,
  Info,
} from "lucide-react";

import { Button } from "@/components/ui/button";
import { expDarkIcon } from "@/lib/Images";
import { InfoBadge, StatusBadge } from "@/components/common/ProfileBadges";
import CircleLoader from "@/components/common/ActionLoader";
import { acmeLogoIcon } from "@/lib/Images";

const TenantHero = ({ tenant, onEdit, isLoading, isFetching }) => {
  const isIncompleteold =
    tenant?.status === "ACTIVE" && tenant?.activeStatus === "INACTIVE";

    const isIncomplete = Number(tenant?.setupStep) < 4;

  const displayStatus = isIncomplete
    ? "Tenant Setup Incomplete"
    : tenant?.status;
  if (isLoading || isFetching || !tenant) {
    return (
      <div className="flex min-h-[320px] items-center justify-center rounded-lg border border-[#254769] bg-brand-100/70">
        <CircleLoader loading={isLoading || isFetching} size={64} />
      </div>
    );
  }

  return (
    <div className="relative overflow-hidden rounded-lg border border-[#254769] bg-brand-100/70 px-8 py-8">
      <div className="absolute inset-0 opacity-50">
        <div className="h-full w-full bg-[radial-gradient(circle_at_30%_30%,rgba(95,42,125,0.8),transparent_35%),radial-gradient(circle_at_70%_40%,rgba(0,211,242,0.15),transparent_30%)]" />
      </div>

      <div className="relative z-10 flex flex-col gap-8 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-col gap-5 sm:flex-row sm:items-center">
          <div className="flex h-28 w-28 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white">
            <img
              // src={tenant?.branding?.logoUrl}
              src={`${tenant?.branding?.logoUrl || acmeLogoIcon}?v=${tenant?.updatedAt}`}
              alt="Tenant Logo"
              className="h-full w-full rounded-full object-cover"
            />
          </div>

          <div>
            <div className="mb-2 flex flex-wrap items-center gap-3">
              <h1 className="text-3xl font-bold">{tenant.orgName}</h1>

              <Button
                type="button"
                onClick={onEdit}
                className="h-8 rounded-md bg-brand-21 px-3 text-xs font-bold text-neutral-100 hover:bg-brand-22"
              >
                <PencilLine className="mr-2 h-4 w-4" />
                Edit Organisation
              </Button>
            </div>

            <p className="mb-3 text-sm text-neutral-100/75">
              Created{" "}
              {new Date(tenant.createdAt).toLocaleDateString("en-US", {
                month: "short",
                day: "numeric",
                year: "numeric",
              })}
            </p>

            <div className="flex flex-wrap items-center gap-3">
              {/* <StatusBadge className="bg-[#064D23] text-[#00E261]">
                {tenant.status}
              </StatusBadge> */}
              <StatusBadge
                className={
                  isIncomplete
                    ? "bg-[#4A1D1D] text-[#FF6B6B]"
                    : "bg-[#064D23] text-[#00E261]"
                }
              >
                <span className="flex items-center gap-1">
                  {isIncomplete && <Info className="h-3.5 w-3.5" />}
                  {displayStatus}
                </span>
              </StatusBadge>
              <StatusBadge className="bg-[#332F00] text-[#D4C300]">
                {tenant.industryType}
              </StatusBadge>

              <InfoBadge icon={<Users className="h-4 w-4 text-[#00D3F2]" />}>
                {tenant.noOfUsers} Users
              </InfoBadge>

              <InfoBadge icon={<Target className="h-4 w-4 text-[#00D3F2]" />}>
                {tenant.noOfCampaigns} campaigns
              </InfoBadge>

              <InfoBadge icon={<img src={expDarkIcon} className="h-4 w-4" />}>
                {tenant.noOfSessions} sessions
              </InfoBadge>
            </div>
          </div>
        </div>

        <div className="space-y-4 text-sm font-medium text-neutral-100/85">
          <ContactRow
            icon={<User className="h-5 w-5" />}
            text={tenant.contactPerson}
          />
          <ContactRow icon={<Mail className="h-5 w-5" />} text={tenant.email} />
          <ContactRow
            icon={<Phone className="h-5 w-5" />}
            text={tenant.contactNumber}
          />
          <ContactRow
            icon={<Globe className="h-5 w-5" />}
            text={tenant.website}
          />
        </div>
      </div>
    </div>
  );
};

const ContactRow = ({ icon, text }) => {
  return (
    <div className="flex items-center gap-4">
      <span className="text-neutral-100/70">{icon}</span>
      <span>{text}</span>
    </div>
  );
};

export default TenantHero;
